import { tns } from 'tiny-slider'
import { registerComponent } from '../components-front';

document.addEventListener('DOMContentLoaded', _ => { 
    document.querySelectorAll('.collection-carousel-wrapper').forEach(carouselWrapper => {
        const carousel = carouselWrapper.querySelector('.collection-carousel');
    
        const cols = carousel.dataset.cols || 4
    
        /** @var {HTMLDivElement} prev */
        const prev = carouselWrapper.querySelector('.prev')
        /** @var {HTMLDivElement} next */
        const next = carouselWrapper.querySelector('.next')
    
        const slider = tns({
            container: carousel,
            items: Math.max(2, Math.floor(cols / 2)),
            slideBy: 1,
            gutter: 50,
            controls: true,
            navPosition: 'bottom',
            prevButton: prev,
            nextButton: next,
            arrowKeys: true,
            lazyload: true,
            responsive: {
                768: {
                    items: Math.max(3, Math.floor(cols * 0.75)),
                },
                992: {
                    items: cols,
                },
            },
        })
    });
})
